var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostasSanitarias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.667 25L175 58.3333M158.333 41.6667L120.833 79.1667M95.8333 54.1667L145.833 104.167M137.5 95.8333L83.3333 150H50M50 150V116.667L104.167 62.5M50 150L25 175M62.5 104.167L75 116.667M87.5 79.1667L100 91.6667",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostasSanitarias);
export default __webpack_public_path__ + "static/media/PostasSanitarias.de8eca7c52beeac565fd614c855ffe5f.svg";
export { ForwardRef as ReactComponent };